import script from "./saleContractReview.vue?vue&type=script&setup=true&lang=js"
export * from "./saleContractReview.vue?vue&type=script&setup=true&lang=js"

import "./saleContractReview.vue?vue&type=style&index=0&id=2a612f4c&lang=less"

const __exports__ = script;

export default __exports__